import { IconProps } from '.'

export function LightbulbIcon({
  width = 26,
  height = 26,
  color = 'currentColor',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 26 35'
      fill={color}
      aria-hidden
      role='img'
      focusable='false'
      {...props}
    >
      <path
        d='M13 34.6667C12.0647 34.6667 11.2707 34.3404 10.6179 33.6876C9.96514 33.0348 9.63875 32.2408 9.63875 31.3055H16.3612C16.3612 32.2408 16.0349 33.0348 15.3821 33.6876C14.7293 34.3404 13.9353 34.6667 13 34.6667ZM6.27792 29.028V26.2501H19.7221V29.028H6.27792ZM6.55542 24.0001C4.6943 22.8242 3.21986 21.3197 2.13208 19.4863C1.04403 17.653 0.5 15.6113 0.5 13.3613C0.5 9.94466 1.72917 7.00716 4.1875 4.54883C6.64583 2.09049 9.58333 0.861328 13 0.861328C16.4167 0.861328 19.3542 2.09049 21.8125 4.54883C24.2708 7.00716 25.5 9.94466 25.5 13.3613C25.5 15.6113 24.9607 17.653 23.8821 19.4863C22.8032 21.3197 21.324 22.8242 19.4446 24.0001H6.55542ZM7.5 21.2222H18.5279C19.8335 20.3333 20.8589 19.1991 21.6042 17.8197C22.3494 16.4399 22.7221 14.9538 22.7221 13.3613C22.7221 10.6761 21.7731 8.38438 19.875 6.48633C17.9769 4.588 15.6853 3.63883 13 3.63883C10.3147 3.63883 8.02306 4.588 6.125 6.48633C4.22694 8.38438 3.27792 10.6761 3.27792 13.3613C3.27792 14.9538 3.65056 16.4399 4.39583 17.8197C5.14111 19.1991 6.17583 20.3333 7.5 21.2222Z'
        fill={color}
      />
    </svg>
  )
}
